import { useAtom } from '@reatom/npm-react'

import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { TableAmountCell } from '@root/features/trade/tables/table-cell/table-amount-cell'

import type BigNumber from 'bignumber.js'

type HolderTableBalanceCellProps = {
  balance: BigNumber
}
export const HolderTableBalanceCell = (props: HolderTableBalanceCellProps) => {
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)

  return <TableAmountCell amount={props.balance} currency={nativeCurrency} />
}
